import { useRouter } from 'next/router';

import { WEB_URL } from '~constant/env';
import useGetCompanyInfo from '~hooks/query/company/useCompanyInfo';
import useMoveOneIdPage from '~hooks/useMoveOneIdPage';
import { setGtmDataLayer } from '~utils/common/thirdPartyEvent';

import ButtonDetail from '../ButtonDetail';
import * as S from './style';

interface Props {
  companyId: string;
  type: 'rookie' | 'career';
}

export default function SignupNudgeWikiChart({ companyId, type }: Props) {
  const router = useRouter();
  const moveOneIdPage = useMoveOneIdPage();
  const { data } = useGetCompanyInfo(companyId);

  const handleClick = () => {
    moveOneIdPage({
      beforeUrl: `${WEB_URL}${router.asPath}#wiki-salary`,
      messageKey: 'kreditjob_company_bookmark_title',
    });

    setGtmDataLayer('company__salary__graph__click', {
      companyId: data?.id,
      companyName: data?.name,
      graphType: type === 'rookie' ? '신입 예상 연봉' : '경력 예상 연봉',
    });
  };

  return (
    <S.Wrapper onClick={handleClick}>
      <S.Message>실제 데이터는 예시 화면과 다를 수 있습니다.</S.Message>
      <picture>
        <source
          srcSet={`/images/img-sample-${type}-salary-chart@2x.png 2x`}
          media='(max-width: 767px)'
        />
        <source srcSet={`/images/img-sample-${type}-salary-chart@2x.png 2x`} />
        <S.Img srcSet={`/images/img-sample-${type}-salary-chart.png 2x`} alt='' />
      </picture>
      <S.ButtonWrapper>
        <ButtonDetail variant='magenta' />
      </S.ButtonWrapper>
    </S.Wrapper>
  );
}
